import Immutable from 'immutable';
import { createStructuredSelector } from 'reselect';

import ApiService from 'services/ApiService/ApiService';
import { MONTH_AS_DAYS } from 'enum/timeFormat';
import {
  convertTokensToDollars,
  usernameOrImpersonate,
} from 'utils/helpers';

import { STUDIO_BROKER_INSIGHTS } from './Api';


const CHANGE_PAGE = 'cam4/topearners/CHANGE_PAGE';
const CHANGE_ROWS_PER_PAGE = 'cam4/topearners/CHANGE_ROWS_PER_PAGE';
const CHANGE_ORDER = 'cam4/topearners/CHANGE_ORDER';
const CHANGE_ORDER_BY = 'cam4/topearners/CHANGE_ORDER_BY';
const GET_EARNINGS = 'cam4/topearners/GET_EARNINGS';

const initialState = Immutable.fromJS({
  data: [],
  selected: [],
  numSelected: 0,
  page: 0,
  order: 'asc',
  orderBy: 'calories',
  rowsPerPage: 10,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_EARNINGS:
      return state.set('data', action.earningsbyday);

    case CHANGE_PAGE:
      return state.set('page', action.page);

    case CHANGE_ROWS_PER_PAGE:
      return state.set('rowsPerPage', action.rowsPerPage);

    case CHANGE_ORDER:
      return state.set('order', action.order);

    case CHANGE_ORDER_BY:
      return state.set('orderBy', action.orderBy);

    default:
      return state;
  }
}

export const NAME = 'topearners';

const topearners = (state) => state[NAME];

const data = (state) => state[NAME].get('data');
const selected = (state) => state[NAME].get('selected');
const numSelected = (state) => state[NAME].get('numSelected');
const order = (state) => state[NAME].get('order');
const page = (state) => state[NAME].get('page');
const orderBy = (state) => state[NAME].get('orderBy');
const rowsPerPage = (state) => state[NAME].get('rowsPerPage');

export const selector = createStructuredSelector({
  topearners,
  data,
  selected,
  numSelected,
  order,
  orderBy,
  rowsPerPage,
  page,
});

function changePage(event, page) {
  return {
    type: CHANGE_PAGE,
    page,
  };
}

function changeRowsPerPage(rowsPerPage) {
  return {
    type: CHANGE_ROWS_PER_PAGE,
    rowsPerPage,
  };
}

function changeOrder(order) {
  return {
    type: CHANGE_ORDER,
    order,
  };
}

function changeOrderBy(orderBy) {
  return {
    type: CHANGE_ORDER_BY,
    orderBy,
  };
}

function updatePerformerEarnings(data) {
  return {
    type: GET_EARNINGS,
    earningsbyday: data,
  };
}

function formatDate(date) {
  const d = new Date(date);
  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = d.getFullYear();

  if (month.length < 2) {
    month = `0${month}`;
  }
  if (day.length < 2) {
    day = `0${day}`;
  }

  return [year, month, day].join('-');
}

function parseResults(res) {
  const data = [];
  let counter = 0;

  res.data?.forEach?.((n) => {
    data[counter] = n;
    data[counter].amount = convertTokensToDollars(n.amount);
    data[counter].id = counter;
    data[counter].key = counter;
    data[counter].amountPerHour = convertTokensToDollars(
      data[counter].hours ? (data[counter].amount / data[counter].hours).toFixed(2) : 0
    );
    counter += 1;
  });

  return (dispatch) => {
    dispatch(updatePerformerEarnings(data));
  };
}

function getPerformerEarnings(user) {
  const today = new Date();
  const earlier = new Date();
  const parsedUrl = ApiService.substitute(STUDIO_BROKER_INSIGHTS, { username: usernameOrImpersonate(user) });
  earlier.setDate(today.getDate() - MONTH_AS_DAYS);

  return (dispatch) => {
    const params = {
      from: formatDate(earlier),
      to: formatDate(today),
    };

    ApiService
      .get(parsedUrl, { params })
      .then((res) => {
        dispatch(parseResults(res));
      });
  };
}

export const actionCreators = {
  getPerformerEarnings,
  updatePerformerEarnings,
  changePage,
  changeRowsPerPage,
  changeOrder,
  changeOrderBy,
};
